module.exports = __webpack_public_path__ + "static/media/delegates.92e77759.svg";